export default __webpack_public_path__ + "static/media/team.d4cd8409.png";